import type { ExperimentConfig } from '../@types'

// DEV-34990: Lymphatic Tai Chi Walking narrative on the first screens.
// Launches on the `Lymphatic%` utm_campaign cohort, all countries — the audience does that gating.
const config: ExperimentConfig[] = [
	{
		'main-tai-chi-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=main-tai-chi-walking&exp=web_tai_chi_walking_adapted_first_screen_by_utm~1
			landing: {
				ids: ['loader-tai-chi-walking-lymphatic', 'age-tai-chi-walking-lymphatic'],
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_walking_adapted_first_screen_by_utm~1
			landing: {
				ids: ['loader-tai-chi-walking-f-lymphatic', 'age-tai-chi-walking-f-lymphatic'],
			},
			// A listed locale with no config file fails the config load (SurveyManager.vue:159),
			// so this array must never run ahead of the files in configs/<id>/.
			funnel: {
				id: 'ob-female-tai-chi-walking-v2-lymphatic',
				locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
			},
		},
	},
]

export default config
